<template>
    <div 
        class="notificationlist">
            <div class="notifaction">
                <h1>Notifications</h1>
                <a 
                    @click.prevent="markallasread"
                    class="markallasread"
                    href=""><b-icon icon="check-all"></b-icon> </a>

                <a 
                    @click.prevent="$emit('update:show', false)"
                    class="closenotif"
                    href="" >
                    <b-icon icon="x"></b-icon>
                </a>
            </div>

            <div class="accordion" role="tablist">
                <template v-for="(group, index) in unreadgroup">
                    <div :key="index" class="historyItem">

                        <b-container>
                            <h1>{{ group.date | formatreldate }}</h1>

                            <template v-for="nt in group.notifs">

                                <b-card 
                                    @click="markasread(nt.id)"
                                    :key="nt.id+'notif'"
                                    no-body class="mb-1">

                                    <b-card-header 
                                        header-tag="header" class="p-1" role="tab">
                                        <div  
                                            class="historyTrail">
                                            
                                            <div class="trailTime">{{nt.updated_at | forceformatdate('hh:mm A')}}</div>

                                            <div class="tailDetails">
                                                <!-- <span
                                                    :style="`background-image : url(https://picsum.photos/seed/${Math.random()}/600/400);`"
                                                    class="deliveryImage"
                                                >
                                                </span> -->

                                                <div class="historyDetail">
                                                    <h3>
                                                        {{Array.isArray(nt.data) ? nt.data[0].from_name : nt.data.from_name}}
                                                    </h3>

                                                    <p>{{Array.isArray(nt.data) ? nt.data[0].message : nt.data.message}}</p>
                                                </div>

                                                
                                            </div>
                                        </div>
                                        
                                    </b-card-header>
                                </b-card>

                                
                            </template>
                        </b-container>
                    </div>
                </template>
            </div>

    </div>
</template>

<script>

/**
 * Declerations
 */
// plugins
import axios from 'axios'
import moment from 'moment'

// mixins


// helpers
import Helper from '@/helpers/helper'
import {newJob} from '@/helpers/localbase'


export default {
    props : {
        show : {
            type   : Boolean,
            default: () => false
        }
    },
    
    data() {
        return {
            currentnotifpage : null
        }
    },
    computed :  {
        /**
         * Unread notification group
         * 
         */
        unreadgroup(){
            return this.notificationgrouping()
        },
        /**
         * Unread notif list
         * 
         */
        unreadnotifs : {
            get() {
                return this.$store.state.unreadnotifs
            },
            set(list) {
                this.$store.commit('updateunreadnotifs', list)
            }
        },
        /**
         * Logged in user
         */
        user () {
            return this.$store.state.user
        },
        /**
         * Network status
         * 
         */
        isonline() {
            return this.$store.state.isonline
        }
    },
    filters : {
        /**
         * Format date by 
         * @param format
         */
        formatdate(date, format) {
            return date ? Helper.formatdate(date, format) : ''
        },
        /**
         * Format date by 
         * @param format
         */
        forceformatdate(date, format) {
            return date ? Helper.formatdate(date, format, true) : ''
        },
        /**
         * Format date by relation like
         * Today, Tomorrow, and MM/DD/YYYY
         */
        formatreldate(date) {
            return Helper.datestring(date)
        }
    },
    methods : {
        /**
         * Mark all notification as read
         */
        markallasread() {
            this.unreadnotifs.forEach(notif => {
                const url = `/update_notification/${notif.id}`
                newJob({
                    url : url,
                    method : "POST"
                })
            })

            this.unreadnotifs = []
        },  
        /**
         * Mark as read notification list
         */
        markasread(notifid) {
            const newlist           = this.unreadnotifs.filter(notf => notf.id != notifid)
                  this.unreadnotifs = newlist;

            const url = `/update_notification/${notifid}`

            axios.post(url).catch(err => console.log(err))
        },
        /**
         * Group notification by date
         * 
         */
        notificationgrouping() {

            let group = []

            this.unreadnotifs.forEach(notif => {
                const exist = group.find(g => moment(g.date).isSame(moment(notif.updated_at), 'day') )

                if(exist) {
                    group = group.map(g => {
                        if(moment(g.date).isSame(moment(notif.updated_at), 'day')) {
                            g.notifs = [...g.notifs, notif]
                        }
                        return g;
                    })
                } else {
                    group = [...group, {
                        date : moment(notif.updated_at).utc(),
                        notifs : [notif]
                    }]
                }
            })

            return group
        },
        
    },
    /**
     * run function before component render
     */
    beforeMount() {
        // get unread notif
        this.$store.dispatch('getunreadnotifs')
    }
}

</script>

<style lang="scss">
@import "@/scss/partials/_colors.scss";
@import "@/scss/partials/_mixins.scss";

.notificationlist {
    position        : absolute;
    min-height      : initial;
    max-height      : 400px;
    width           : 300px;
    overflow        : hidden auto;
    z-index         : 503;
    background-color: #fff;
    overflow        : auto;
    top             : 30px;
    right           : 0;

    @include boxShadow;

    @include screen-up(md) {
        position  : fixed;
        top       : 0;
        left      : 0;
        right     : 0;
        bottom    : 0;
        min-height: 100vh;
        width     : 100%;
        max-height: initial;
        box-shadow: none;
    }

    .notifaction {
        display        : flex;
        align-items    : center;
        padding        : 30px 15px 15px;

        h1 {
            font-size    : 20px;
            margin-bottom: 0;
            font-weight  : 800;
            color        : $primaryColor;
        }

        .b-icon.bi {
            font-size: 25px;
        }

        a {
            display    : flex;
            align-items: center;
            margin-left: 15px;


            &:hover {
                color : $primaryColor;
            }

            &.markallasread {
                margin-left: auto;
            }
        }
    }

    .historyItem {
        padding-top  : 30px;
        border-bottom: 10px solid $lightgrey;

       
        h1 {
            font-size  : 15px;
            font-weight: 700;
            color      : $primaryColor;
        }
    }

    .orderTrail {
        padding-left : 30px;

        


        .orderTrailItem {
            display    : flex;
            border-left: 1px solid $lightgrey2;
            
            &:last-child {
                border : none;
            }

            .trailType {
                width           : 50px;
                height          : 50px;
                flex            : 0 0 50px;
                margin-right    : 15px;
                margin-left     : -25px;
                border-radius   : 100%;
                display         : flex;
                align-items     : center;
                justify-content : center;
                background-color: $lightgrey;
                font-size       : 25px;

                &.done {
                    background-color: $primaryColor;
                    color           : white;
                }
            }

            .trailDetails {
                h4 {
                    font-size    : 20px;
                    font-weight  : 700;
                    margin-bottom: 0;
                }
            }

            .trailAction {
                .btn {
                    width  : 130px;
                    height : 40px;
                    padding: 0;
                }
            }
        }
    }

    .historyTrail {
        display       : flex;
        padding-top   : 15px;
        padding-bottom: 15px;

        

        .trailTime {
            color       : $grey;
            margin-right: 15px;
            display     : block;
            white-space : nowrap;
        }

        .tailDetails {
            display: flex;
            width  : 100%;

            .deliveryImage {
                flex               : 0 0 50px;
                width              : 50px;
                height             : 50px;
                display            : block;
                border-radius      : 100%;
                background-size    : cover;
                background-position: center;
                margin-right       : 15px;
            }

            h3 {
                font-size: 18px;
                font-weight: 700;
                margin-bottom: 0;
            }

            p {
                color: $grey;
                margin-bottom: 0;
            }
        }
    }

    .collapse {
        &.show {
            border-bottom : 10px solid $lightgrey;
        }
    }

    .accordion {
        .card {
            &:hover {
                background: $lightgrey;
            }
        }

        header {
            .not-collapsed {
                width : 100%;

                .historyDetail {
                    flex : 1;
                }
                
                .deliveryImage {
                    display: none;
                }

                .collapseIcon {
                    flex : 0 0 30px;
                }
            }
        }
    }
}

#cancelDeliverHistory {
    img {
        margin-left : auto;
        margin-right: auto;
        display     : block;
    }

    .modal-body {
        padding-left : 30px;
        padding-right: 30px;
        text-align   : center;
        
    }
}
</style>
